import { Component, OnInit, ViewChildren, QueryList } from "@angular/core";
import { LoaderService } from "@app/core/services/loader/loader.service";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { DesignModel } from "@app/shared/models/design";
import { InksoftService } from "@app/shared/services/inksoft/inksoft.service";
import { NotificationService } from "@app/core/services/notification/notification.service";
import {
  FilterModel,
  FilterList,
  ProductList,
  CategoryModel,
  SubCategoryModel,
} from "@app/shared/models/product";
import { ProductService } from "@app/shared/services/product/product.service";
import { MatDialog } from "@angular/material/dialog";
import { PublishProductComponent } from "@app/shared/components/publish-product/publish-product.component";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ErrorhandlerService } from "@app/shared/services/errorhandler/errorhandler.service";
import { environment } from "@env/environment";
import { EncrDecrService } from "../../../../../shared/services/encr-decr-service.service";
import { CryptoKeyValue } from "../../../../../shared/constants";
import { ConfirmationDialogComponent } from "@app/shared/components/confirmation-dialog/confirmation-dialog.component";
import { AddProductPopupCompData } from "@app/shared/models/product";
import { StateService } from "@app/shared/services/state/state.service";
import { LocalStorageService } from "@app/core/services/localStorage/local-storage.service";
import { IMasterProductSizeDetails } from "@app/shared/services/product/getProductDetailsByProductId.interface";
import {
  ProductLibraryColorModel,
  ProductLibraryModel,
} from "@app/shared/models/customized-product.interface";
import { DesignHuddleImageService } from "@app/shared/services/design-huddle/design-huddle-image.service";

@Component({
  selector: "app-customized-product",
  templateUrl: "./customized-product.component.html",
  styleUrls: ["./customized-product.component.css"],
})
export class CustomizedProductComponent implements OnInit {
  mobileScreen: boolean = false;
  searchString: any = '';
  // -------------------------
  searchCustomizedForm!: FormGroup;

  customizedProducts!: ProductLibraryModel[];
  designModel!: DesignModel;
  // designId !: number;
  // newDesignId !: number;
  productId = localStorage.getItem("productIdToBeDesigned");
  styleId = localStorage.getItem("styleIdToBeDesigned");
  userRole = localStorage.getItem("role");
  isSuperAdmin = "";
  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL = environment.productCustomImageFolder;
  wareHouseImageUrl = environment.warehouseProductCustomImageFolder;
  ApplicationUserId!: any;
  /** filtermodel holds filtering data to get filtered records from API */
  filterModel: FilterModel;
  /** Filter list is for master filter list record */
  filterList: FilterList = {
    Categories: [],
    Brands: [],
    Colors: [],
    Sizes: [],
  };
  // For Infinite scroll of grid
  throttle = 100;
  scrollDistance = 6;
  isFullListDisplayed: boolean = false;
  pageSize = 10; // No of items to load from server side i.e no of items to take
  pageIndex = 0;
  totalRecordsCount = 0;
  currentRecordsCount = 0;
  scrolling = false;
  screenPrint: boolean = true;
  embroidery: boolean = true;
  IsSuperAdmin = localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'CustomerService';

  fn_SampleOrder(productID: any, designId: any, IsShopify: boolean) {
    var encProductID = this.EncrDecr.set(
      CryptoKeyValue.Key,
      productID.toString()
    );
    var encdesignId = this.EncrDecr.set(
      CryptoKeyValue.Key,
      designId.toString()
    );
    //productID = this.EncrDecr.get(CryptoKeyValue.Key, productID.toString())
    // designId = this.EncrDecr.get(CryptoKeyValue.Key, designId.toString())
    
    var encProductID = this.EncrDecr.set(CryptoKeyValue.Key, productID.toString());
    var encdesignId = this.EncrDecr.set(CryptoKeyValue.Key, designId.toString())
    localStorage.setItem("sampleOrder", "1");
    this.router.navigate(["/store/product/details"], {
      queryParams: {
        pid: encProductID,
        designId: encdesignId,
        type: 1,
        IsShopifyProduct: IsShopify,
        IsSuperAdmin: this.isSuperAdmin,
      },
    });
  }
  fn_ProductDetails(
    productID: any,
    designId: any,
    index: number,
    IsShopify: boolean
  ) {
    var product = this.customizedProducts[index];
    var encProductID = this.EncrDecr.set(
      CryptoKeyValue.Key,
      productID.toString()
    );
    var encdesignId = this.EncrDecr.set(
      CryptoKeyValue.Key,
      designId.toString()
    );
    localStorage.setItem("sampleOrder", "0");
    if (product.IsWarehouseProduct) {
      this.router.navigate(["/store/product/details"], {
        queryParams: {
          pid: product.EncryptedId,
          designId: 0,
          type: 2,
          IsSuperAdmin: this.isSuperAdmin,
        },
      });
    } else {
      this.router.navigate(["/store/product/details"], {
        queryParams: {
          pid: encProductID,
          designId: encdesignId,
          type: 1,
          IsShopifyProduct: IsShopify,
          IsSuperAdmin: this.isSuperAdmin,
        },
      });
    }
  }
  // productsCount = 0;
  catListDB: any[] = [];
  colorDB: any[] = [];
  BrandDB: any[] = [];
  isDisableFilterBtn = true;
  categoryList: CategoryModel[] = [];
  subCategoryList: SubCategoryModel[] = [];
  catlist: any[] = [];
  @ViewChildren("brandCheckbox") private brandCheckboxes!: QueryList<any>;
  @ViewChildren("colorCheckbox") private colorCheckboxes!: QueryList<any>;
  @ViewChildren("sizeCheckbox") private sizeCheckboxes!: QueryList<any>;
  inkSoftUserId: any;
  // To show hide 'No record div'
  isDisplay = "none";

  // Material paginator fields
  // pageEvent!: PageEvent;
  // pageIndex = 0;
  // length = 0; // Total items count
  styleIds: number[];

  constructor(
    private loader: LoaderService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private inksoftService: InksoftService,
    private notification: NotificationService,
    private productService: ProductService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private errorhandlerService: ErrorhandlerService,
    private EncrDecr: EncrDecrService,
    private stateService: StateService,
    private localstorageService: LocalStorageService,
    private designHuddleImageService: DesignHuddleImageService
  ) {
    this.ApplicationUserId = this.localstorageService.get("userId");
    this.customizedProducts = [];
    this.currentRecordsCount = 0;
    this.searchCustomizedForm = this.formBuilder.group({
      searchProduct: [""],
    });
  }

  ngOnInit() {
    this.mobileScreen = $(window).width() >= 768 ? false : true;
    this.filterModel = {
      Skip: 0,
      Take: this.pageSize,
      Size: [],
      Brand: [],
      Color: [],
      InkSoftUserId: 0,
      searchBy: "",
      Category: "",
      Embroidery: true,
      ScreenPrint: true,
    };
    if (this.userRole == "SuperAdmin") {
      this.isSuperAdmin = "true";
    } else {
      this.isSuperAdmin = "false";
    }
    // const isSmallScreen = breakpointObserver.isMatched('(max-width: 599px)');
    this.inkSoftUserId =
      localStorage.getItem("inksoftUserId") !== null
        ? localStorage.getItem("inksoftUserId")
        : "";
    localStorage.setItem("sampleOrder", "0");
    this.initialize();
    // if (this.designId !== 0 && this.designId !== null && this.designId !== undefined) {
    //   if (this.newDesignId !== 0 && this.newDesignId !== null && this.newDesignId !== undefined) {
    //     this.fn_SaveDesign(this.designId, this.newDesignId);
    //   } else {
    //     this.fn_SaveDesign(this.designId);
    //   }
    // } else {
    this.fn_GetSavedDesignListing();
    this.fn_GetFilters();
    // }
  }

  initialize() {}

  editProduct(
    ProductId: any,
    DesignId: any,
    styleID: any,
    IsShopifyProduct: boolean
  ) {
    this.loader.show();
    const storeId = localStorage.getItem('storeId') || '';

    // Use huddle edit flow (same as super-admin)
    this.productService
      .getCustomizedProductDetailsWithStyle({
        productId: ProductId,
        designId: DesignId,
        storeId: Number(storeId) || 0
      })
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.StatusCode === 200 && res.Data?.ResponseData) {
          const groupedData = res.Data.ResponseData;
          const productGrouped = Array.isArray(groupedData) ? groupedData[0] : groupedData;

          // Find the product from the current list
          const listItem = this.customizedProducts.find(p => p.ProductId === ProductId);

          // Merge SavedStyles from all CustomizedProducts
          const allSavedStyles = (productGrouped.CustomizedProducts || []).reduce((acc: any[], cp: any) => {
            return acc.concat(cp.SavedStyles || []);
          }, []);

          // Build flat productDetails object for downstream components
          const firstCP = productGrouped.CustomizedProducts?.[0] || {};
          const productDetails = {
            ...productGrouped,
            CustomizedProductId: firstCP.CustomizedProductId,
            StyleId: firstCP.StyleId || styleID,
            Name: firstCP.Name,
            PngRelativeUrlWithProduct: firstCP.PngRelativeUrlWithProduct,
            ThumbnailRelativeUrl: firstCP.ThumbnailRelativeUrl,
            PngRelativeUrl: firstCP.PngRelativeUrl,
            SvgRelativeUrl: firstCP.SvgRelativeUrl,
            PrintRegion: firstCP.PrintRegion,
            SideDisplayName: firstCP.SideDisplayName,
            SideName: firstCP.SideName,
            ProductMetadata: firstCP.ProductMetadata,
            Tags: firstCP.Tags,
            DesignHuddleProjectId: firstCP.DesignHuddleProjectId,
            DesignHuddleTemplateId: firstCP.DesignHuddleTemplateId,
            DesignHuddleJobId: firstCP.DesignHuddleJobId,
            AzureBlobThumbnailUrl: firstCP.AzureBlobThumbnailUrl,
            AzureBlobPrintFileUrl: firstCP.AzureBlobPrintFileUrl,
            Customizations: firstCP.Customizations,
            ElementPlacement: firstCP.ElementPlacement,
            ZonePlacement: firstCP.ZonePlacement,
            RetailPrice: firstCP.RetailPrice,
            PrintingCost: firstCP.PrintingCost,
            SavedStyles: allSavedStyles,
            Sizes: firstCP.Sizes,
            CustomizedProducts: productGrouped.CustomizedProducts
          };

          // Set edit mode with full product data
          const editData = {
            ProductId: ProductId,
            DesignId: DesignId,
            StyleId: styleID,
            IsShopifyProduct: IsShopifyProduct,
            productDetails: productDetails,
            listItem: listItem,
            storeId: storeId,
            storeName: localStorage.getItem('storeName') || ''
          };

          this.stateService.setEditMode(true, editData);

          // Set design data from existing product
          let designUrl = '';
          const firstCPCustomizations = firstCP.Customizations;
          if (firstCPCustomizations) {
            try {
              const parsed = typeof firstCPCustomizations === 'string'
                ? JSON.parse(firstCPCustomizations) : firstCPCustomizations;
              designUrl = parsed?.classes?.logo?.url || '';
            } catch (e) { }
          }
          if (!designUrl && listItem?.PngRelativeUrl) {
            designUrl = listItem.PngRelativeUrl.startsWith('http')
              ? listItem.PngRelativeUrl
              : this.imgBaseURL + listItem.PngRelativeUrl;
          }
          const previewUrl = listItem?.PngRelativeUrlWithProduct
            ? (listItem.PngRelativeUrlWithProduct.startsWith('http')
              ? listItem.PngRelativeUrlWithProduct
              : this.imgBaseURL + listItem.PngRelativeUrlWithProduct)
            : designUrl;

          this.stateService.setDesignData({
            type: 'uploaded',
            logoUrl: designUrl,
            previewUrl: previewUrl,
            designUrl: designUrl,
            fileName: '',
            file: null,
            isEdit: true,
            designId: DesignId
          });

          // Navigate to huddle edit-master-product page
          this.router.navigate(['/store/edit-master-product'], {
            queryParams: { storeId: storeId, storeName: localStorage.getItem('storeName') || '' }
          });
        } else {
          this.notification.error('Failed to load product details', 'Error');
        }
      }, (err: any) => {
        this.loader.hide();
        this.notification.error('Error loading product details', 'Error');
      });
  }

  updateProductList(withResetProduct: any) {
    if (withResetProduct.reset) {
      this.fn_ResetProductList();
    }
    this.fn_ResetProductList();
    this.searchString = this.searchCustomizedForm.controls["searchProduct"].value || '';
    this.screenPrint = withResetProduct.screenPrint;
    this.embroidery = withResetProduct.embroidery;
    this.fn_GetSavedDesignListing();
  }

  fn_searchCustomizeProduct(form: FormGroup) {
    const newSearchString = form.controls["searchProduct"].value;
    // Skip if search term hasn't changed (prevents blank flash on blur)
    if (newSearchString === this.searchString) {
      return;
    }
    this.isDisplay = "none";
    this.fn_ResetProductList();
    this.searchString = newSearchString;
    this.filterModel.Skip = 0;
    this.filterModel.searchBy = this.fn_CheckForNullUndefinedEmptyString(
      this.searchString
    );
    this.fn_GetSavedDesignListing();
  }

  /** Get master filters data for product(s) */
  fn_GetFilters() {
    this.filterList.Categories = [];
    this.filterList.Brands = [];
    this.filterList.Colors = [];
    this.filterList.Sizes = [];
    this.productService
      .getCustomProductFiltersData(this.ApplicationUserId)
      .subscribe(
        (res: any) => {
          if (res.Message === "Success" || res.StatusCode === 200) {
            this.filterList.Categories = res.Data.Categories;
            this.filterList.Brands = res.Data.FilterModel.Brands;
            this.filterList.Colors = res.Data.FilterModel.Colors;
            this.filterList.Sizes = res.Data.FilterModel.Sizes;
          }
        },
        (err: any) => {}
      );
  }

  /** Modify filter model for selected brand */
  fn_SelectBrand(event: any, brandId: number) {
    if (this.filterModel.Brand.length > 0) {
      for (let i = 0; i < this.filterModel.Brand.length; i++) {
        if (this.filterModel.Brand[i] === brandId && !event.checked) {
          this.filterModel.Brand.splice(i, 1);
        }
      }
    }
    if (event.checked) {
      this.filterModel.Brand.push(brandId);
    }
    this.filterModel.Skip = 0;
    this.filterModel.Take = this.pageSize;
    // this.filterModel.searchBy = '';
    this.fn_ResetProductList();
    this.fn_GetSavedDesignListing();
  }

  /** Resets product list */
  fn_ResetProductList() {
    this.customizedProducts = [];
    this.isFullListDisplayed = false;
    this.scrolling = false;
    this.currentRecordsCount = 0;
    this.totalRecordsCount = 0;
    this.pageIndex = 0;
  }

  /** Enable/Disale(s) reset filter button */
  fn_EnableDisableResetFilterBtn() {
    if (
      this.filterModel.Size.length > 0 ||
      this.filterModel.Brand.length > 0 ||
      this.filterModel.Color.length > 0 ||
      this.filterModel.Category !== ""
    ) {
      this.isDisableFilterBtn = false;
    } else {
      this.isDisableFilterBtn = true;
    }
  }
  /** Function to uncheck all the filter(s) */
  fn_UncheckFilterCheckboxes() {
    this.brandCheckboxes.toArray().forEach((element) => {
      element.checked = false;
    });

    this.colorCheckboxes.toArray().forEach((element) => {
      element.checked = false;
    });

    this.sizeCheckboxes.toArray().forEach((element) => {
      element.checked = false;
    });
  }

  /** Function to save newly customized product to database */
  fn_SaveDesign(designId: number, newDesignId?: number) {
    this.loader.show();
    this.designModel = {
      DesignId: designId,
      NewDesignId: newDesignId,
      ProductId: this.productId !== null ? +this.productId : 0,
      StyleId: this.styleId !== null ? +this.styleId : 0,
      ApplicationUserId: localStorage.getItem("userId"),
      CopiedDesignId: null,
    };
    let result;
    //if (newDesignId) {
    //  this.designModel.NewDesignId = newDesignId;
    //  result = this.inksoftService.updateCustomizedDesign(this.designModel);
    //} else {
    if (isNaN(newDesignId)) {
      this.loader.hide();
      this.fn_GetSavedDesignListing();
    } else result = this.inksoftService.saveCustomizedDesign(this.designModel);
    // }

    result.subscribe(
      (res: any) => {
        if (res.Message === "Success" || res.StatusCode === 200) {
          this.notification.success(
            "Product customized successfully",
            "Customization"
          );
          this.router.navigate(["store/customizedproducts"]); // JUST FOR CHANGING THE ROUTE URL IN BROWSER
          this.fn_ResetProductList();
          this.fn_GetSavedDesignListing();
          this.loader.hide();
        } else if (res.StatusCode === 400) {
          this.notification.error("An error occured. Try again", "Error");
          this.loader.hide();
        } else {
          this.notification.error("An error occured. Try again", "Error");
          this.loader.hide();
        }
      },
      (err) => {
        // this.notification.error('Internal server error. Try again', 'Error');
        this.errorhandlerService.handleError(err);
        this.loader.hide();
      }
    );
  }
  displayColor(obj: any) {
    return {
      "background-color": obj,
    };
  }
  selectStyleToCustomize(style: ProductLibraryColorModel, productIndex: any) {
    var customizedProduct = this.customizedProducts[productIndex];
    // let color = customizedProduct.ColorList.find(x => x.StyleId == style.StyleId);
    //for (var i = 0; i < this.customizedProducts[productIndex].length; i++) {
    for (var j = 0; j < customizedProduct.ColorList.length; j++) {
      if (customizedProduct.ColorList[j].StyleId == style.StyleId) {
        if (customizedProduct.IsWarehouseProduct) {
          // var ar = customizedProduct.DefaultImage.split('\\');
          // ar[3] = customizedProduct.ColorList[j].Images[0].Image;
          // customizedProduct.DefaultImage = ar.join('\\');
        } else {
          // var newImg = (customizedProduct.DefaultImage == null || customizedProduct.DefaultImage == undefined || customizedProduct.DefaultImage == "") ? customizedProduct.PngRelativeUrlWithProduct : customizedProduct.DefaultImage;
          // let arr = newImg.split('/');
          // arr[5] = color.ColorName.replace(/ /g, '_');
          // customizedProduct.DefaultImage = arr.join('/');

          this.fn_FetchImageToDisplay(style, customizedProduct);
        }
      }
    }
    //this.customizedProducts[productIndex].PngRelativeUrlWithProduct = color.Image;
    // customizedProduct.IsDefaultImageCustom = false;
    // this.customizedProducts[productIndex].DefaultImage = '';

    // }
  }
  fn_FetchImageToDisplay(
    style: ProductLibraryColorModel,
    obj: ProductLibraryModel
  ) {
    let img = undefined;

    // Check if product has Design Huddle image first
    if (obj.AzureBlobThumbnailUrl) {
      img = obj.AzureBlobThumbnailUrl;
    } else {
      // Fall back to Inksoft logic
      var imgObj = style.Images.sort(function (x, y) {
        // true values first
        return x.IsDefault === y.IsDefault ? 0 : x.IsDefault ? -1 : 1;
      })[0];
      if (imgObj) {
        if (imgObj.IsCustom) img = this.imgCustomBaseURL + imgObj.Image;
        else img = this.imgBaseURL + imgObj.Image;
      }
    }

    obj["StyleId"] = style.StyleId;
    obj["Img"] = img;
    obj["ImgLoaded"] = false;
  }

  /** Function to GET list of customized product(s) */
  fn_GetSavedDesignListing() {
    this.fn_EnableDisableResetFilterBtn();
    //this.loader.show();
    this.loader.lazyLoaderShow();
    // this.filterModel.Skip = this.currentRecordsCount;
    this.filterModel.Skip = this.pageSize * this.pageIndex;
    this.filterModel.InkSoftUserId = this.inkSoftUserId;
    this.filterModel.ScreenPrint = this.screenPrint;
    this.filterModel.Embroidery = this.embroidery;
    this.inksoftService.getCustomizedProductsList(this.filterModel).subscribe(
      (res: any) => {
        if (res.StatusCode === 200 && res.Message === "Success") {
          if (
            res.Data.ResponseData.length > 0 &&
            res.Data.ResponseData !== null
          ) {
            // this.customizedProducts = [];
            res.Data.ResponseData.forEach((obj: ProductLibraryModel) => {
              // check if item with same id exists in the list that we display in front end, amy be the case with paging
              if (obj.IsWarehouseProduct) {
                //for warehouse product it will be always single products
                if (
                  !this.customizedProducts.find(
                    (x) => x.ProductId === obj.ProductId
                  )
                ) {
                  this.currentRecordsCount = this.customizedProducts.push(obj);
                }
              } else {
                // check if item with same id exists
                if (
                  !this.customizedProducts.find(
                    (x) => x.CustomizedProductId === obj.CustomizedProductId
                  )
                ) {
                  let defaultStyle = obj.ColorList.find((c) =>
                    c.Images.some((i) => i.IsDefault)
                  );
                  if (!defaultStyle) defaultStyle = obj.ColorList[0];

                  if (defaultStyle && defaultStyle.Images)
                    this.fn_FetchImageToDisplay(defaultStyle, obj);

                  this.currentRecordsCount = this.customizedProducts.push(obj);
                }
              }
            });

            for (var i = 0; i < res.Data.ResponseData.length; i++) {
              if (
                !this.catListDB.find(
                  (x) =>
                    x.ProductId ===
                    res.Data.ResponseData[i].ProductDescription[0].CategoryIds
                )
              ) {
                var temp =
                  res.Data.ResponseData[i].ProductDescription[0].CategoryIds; //.split(',');
                if (!res.Data.ResponseData[i].IsWarehouseProduct) {
                  if (res.Data.ResponseData[i].StyleName) {
                    this.colorDB.push(
                      res.Data.ResponseData[i].StyleName.trim()
                    );
                  }
                  this.BrandDB.push(
                    res.Data.ResponseData[
                      i
                    ].ProductDescription[0].ProductName.split("|")[1] !=
                      undefined
                      ? res.Data.ResponseData[
                          i
                        ].ProductDescription[0].ProductName.split("|")[1].trim()
                      : res.Data.ResponseData[
                          i
                        ].ProductDescription[0].ProductName.trim()
                  );
                }

                for (var j = 0; j < temp.length; j++) {
                  this.catListDB.push(temp[j]);
                }
              }
            }
            this.totalRecordsCount = res.Data.TotalDataCount;
            this.pageIndex++;
          } else if (res.Data.ResponseData.length === 0) {
            // Only reset if no products loaded yet (first page was empty)
            // Don't wipe existing results when a subsequent page returns empty
            if (this.customizedProducts.length === 0) {
              this.filterModel.Skip = 0;
            }
          }

          if (res.Data.ResponseData.length < this.pageSize) {
            this.isFullListDisplayed = true;
          }
          this.isDisplay = this.currentRecordsCount > 0 ? "none" : "block";
        } else {
          this.notification.error("Internal server error. Try again", "Error");
        }
        this.scrolling = false;
        //this.loader.hide();
        this.loader.lazyLoaderHide();
      },
      (err: any) => {
        this.scrolling = false;
        this.errorhandlerService.handleError(err);
        this.loader.hide();
        this.loader.lazyLoaderHide();
      }
    );
  }

  fn_GetSavedDesignListing_Scroll() {
    if (!this.scrolling) {
      this.scrolling = true;
      this.fn_GetSavedDesignListing();
    }
  }

  /** Opens publish to store popup */
  fn_OpenPublishModal(
    CustomizedProductId: number,
    ProductId: number,
    IsWareHouseProduct: boolean,
    DesignId: number,
    IsPublished: boolean
  ) {
    if (!IsPublished && !IsWareHouseProduct) {
      //this.notification.info('Please complete pricing details to publish a product.', 'info');
      // let data = {
      //   designId: DesignId,
      //   productId: ProductId,
      //   IsPublished: IsPublished
      // }
      // this.dialog.open(AddProductPopupComponent, {
      //   data: { dataInksoft: data, shopifyData: null }
      // });
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message: "Continue product customization!",
          title: "Finish Customization",
          noButton: false,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.loader.show();
        this.productService
          .getAdditionalProductDetails(ProductId, DesignId)
          .subscribe((res) => {
            this.loader.hide();
            if (res.StatusCode === 200 && res.Data.ResponseData) {
              const sizes: IMasterProductSizeDetails[] =
                res.Data.ResponseData.Sizes;

              const data: AddProductPopupCompData = {
                designId: DesignId.toString(),
                ProductId: ProductId.toString(),
                IsPublished: IsPublished,
                haveNoStyles: true,
                shopifyProduct: false,
                isEditCase: true,
                isProductReplaceCase: false,
                ProductAdditionalInfo:
                  res.Data.ResponseData.productAdditionalInfo,
                SizingLabelExist: res.Data.ResponseData.SizingLabelExist,
                SizingLabelImage: res.Data.ResponseData1
                  ? res.Data.ResponseData1.Image
                  : null,
                Sizes: sizes.map<IMasterProductSizeDetails>((s: any) => {
                  return {
                    Name: s.Name,
                    LongName: s.LongName,
                    ID: null,
                    SortOrder: null,
                    Weight: null,
                    UnitPrice: null,
                    AvailableQty: 0,
                  };
                }),
              };
              this.stateService.updateAddProductPopupdata(data);
              this.router.navigate(["/store/addproduct"]);
            }
          });
      });
    } else {
      const dialogRef = this.dialog.open(PublishProductComponent, {
        // minWidth: '580px',
        width: "700px",
        data: {
          CustomizedProductId,
          DesignId,
          IsWareHouseProduct,
          WarehouseProductId: ProductId,
          IsPublished,
        },
      });
      dialogRef.afterClosed().subscribe(() => {
        // this.fn_getStoreList();
      });
    }
  }

  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === "" || value === undefined) {
      return "";
    } else {
      return value;
    }
  }

  /** Get product categories & sub-categories */
  fn_GetCategories() {
    this.productService.getProductCategoyAndSubCategory().subscribe(
      (res) => {
        if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
          this.catlist = res.Data.ResponseData;
          for (let i = 0; i < res.Data.ResponseData.length; i++) {
            this.categoryList.push({
              CategoryId: Number(res.Data.ResponseData[i].ID),
              CategoryName: res.Data.ResponseData[i].Name,
              SubCategoryCount: res.Data.ResponseData[i].SubCategories.length,
            });
            if (res.Data.ResponseData[i].SubCategories.length > 0) {
              for (
                let j = 0;
                j < res.Data.ResponseData[i].SubCategories.length;
                j++
              ) {
                this.subCategoryList.push({
                  ParentCategoryId: Number(res.Data.ResponseData[i].ID),
                  SubCategoryId: Number(
                    res.Data.ResponseData[i].SubCategories[j].ID
                  ),
                  SubCategoryName:
                    res.Data.ResponseData[i].SubCategories[j].Name,
                });
              }
            }
          }
        }
      },
      (err: any) => {
        // this.errorhandlerService.handleError(err);
      }
    );
  }

  /** Function set selected category in filter model */
  fn_SelectCategory(categoryId: string) {
    this.filterModel.Category = "";
    this.fn_ResetProductList();
    this.fn_UncheckFilterCheckboxes();
    this.fn_EnableDisableResetFilterBtn();
    this.filterModel.Category = categoryId;
    this.filterModel.Skip = 0;
    this.filterModel.Take = this.pageSize;
    this.filterModel.searchBy = "";
    this.filterModel.Brand = [];
    this.filterModel.Color = [];
    this.filterModel.Size = [];
    this.fn_GetSavedDesignListing();
  }

  showAddProductWindow() {
    this.router.navigate(["/store/upload-design"]);
  }

  /** delete customized product */
  fn_deleteCustomizedProduct(product) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Are you sure you want to delete this record ?",
        title: "Delete",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.loader.show();

        var deleteCustomizedProduct = {
          DesignId: product.DesignId,
          StyleId: product.StyleId,
          ProductId: product.ProductId,
          UserId: product.ApplicationUserId,
        };

        this.inksoftService
          .deleteCustomizedProduct(deleteCustomizedProduct)
          .subscribe(
            (res: any) => {
              if (res.StatusCode === 200) {
                //Splice that item as it is deleted
                var indexOfDeletedItem = this.customizedProducts.findIndex(
                  (s) =>
                    s.DesignId == product.DesignId &&
                    s.StyleId == product.StyleId &&
                    s.ProductId == product.ProductId
                );

                this.customizedProducts.splice(indexOfDeletedItem, 1);

                this.loader.hide();
                this.notification.success(res.Message, "Success");
              } else {
                this.notification.error(
                  "Internal server error. Try again",
                  "Error"
                );
                this.loader.hide();
              }
            },
            (err) => {
              // this.notification.error('Internal server error. Try again', 'Error');
              this.errorhandlerService.handleError(err);
              this.loader.hide();
            }
          );
      }
    });
  }

  getProductImage(product: any): string {
    return this.designHuddleImageService.getProductThumbnailUrl(product);
  }
}
